import React, { useEffect, useRef, useState, memo, useCallback } from 'react';
import './SearchBar.css';

function SearchBar({ onSearch, onCancel, onEngage, isSearching, hasSearched, resultCount }) {
  const [query, setQuery] = useState('');
  const engagedRef = useRef(false);

  useEffect(() => {
    if (!onEngage || engagedRef.current) {
      return;
    }
    if (query.trim().length > 0) {
      engagedRef.current = true;
      onEngage();
    }
  }, [query, onEngage]);

  const handleSubmit = useCallback(event => {
    event.preventDefault();
    const trimmed = query.trim();
    if (!engagedRef.current && onEngage) {
      engagedRef.current = true;
      onEngage();
    }
    if (isSearching && onCancel) {
      onCancel();
    }
    onSearch(trimmed);
  }, [query, isSearching, onSearch, onCancel, onEngage]);

  const handleInputChange = useCallback(event => {
    setQuery(event.target.value);
  }, []);

  return (
    <div className={`search-bar ${hasSearched ? 'search-bar-compact' : 'search-bar-hero'}`}>
      <form onSubmit={handleSubmit}>
        <div className="search-input-wrapper">
          <input
            type="text"
            value={query}
            onChange={handleInputChange}
            placeholder="keyword, internet address, IP or stream URL"
            className="search-input"
            autoCapitalize="none"
            autoComplete="off"
            autoCorrect="off"
            spellCheck="false"
          />
          <button
            type="submit"
            className={`search-button ${isSearching ? 'search-button-active' : ''}`}
            aria-label={isSearching ? "Cancel search" : "Start search"}
          >
            {isSearching ? (
              <span className="spinner" />
            ) : (
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M19 19L14.65 14.65" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            )}
          </button>
        </div>
      </form>

      {!isSearching && hasSearched && resultCount > 0 && (
        <div className="search-meta">
          <span>{resultCount} results</span>
        </div>
      )}
    </div>
  );
}

export default memo(SearchBar);
